/* eslint-disable @typescript-eslint/explicit-function-return-type */
import type {Routes} from "@angular/router";
import {UserAccountType} from "../../models/users/User";
import {hasUserTypes, isLoggedIn} from "../../services/guards/permission-guard";

export const bactoforceRoutes = [
  // Bactoforce Areas
  {
    path: "bactoforce-areas",
    canActivateChild: [isLoggedIn, hasUserTypes(UserAccountType.Admin)],
    children: [
      {
        path: "",
        loadComponent: () => import("./areas/list/bactoforce-areas-list").then(m => m.BactoforceAreasList),
      },
      {
        path: "create",
        loadComponent: () => import("./areas/form/bactoforce-area-form").then(m => m.BactoforceAreaForm),
      },
    ],
  },

  // Bactoforce Locations
  {
    path: "bactoforce-locations",
    canActivateChild: [isLoggedIn, hasUserTypes(UserAccountType.Admin)],
    children: [
      {
        path: "",
        loadComponent: () => import("./locations/list/bactoforce-locations-list").then(m => m.BactoforceLocationsList),
      },
      {
        path: "create",
        loadComponent: () => import("./locations/form/bactoforce-location-form").then(m => m.BactoforceLocationForm),
      },
      {
        path: ":bfLocationId",
        loadComponent: () => import("./locations/form/bactoforce-location-form").then(m => m.BactoforceLocationForm),
      },
    ],
  },

  // Datasheets
  {
    path: "datasheets",
    canActivateChild: [isLoggedIn],
    children: [
      {
        path: "",
        canActivate: [hasUserTypes(UserAccountType.Admin, UserAccountType.Bactoforce, UserAccountType.Customer)],
        loadComponent: () => import("./datasheets/list/datasheets-list").then(m => m.DatasheetsList),
      },
      {
        path: "create",
        canActivate: [hasUserTypes(UserAccountType.Admin, UserAccountType.Bactoforce)],
        loadComponent: () => import("./datasheets/form/datasheet-form").then(m => m.DatasheetForm),
      },
      {
        path: ":datasheetId",
        canActivate: [hasUserTypes(UserAccountType.Admin, UserAccountType.Bactoforce)],
        loadComponent: () => import("./datasheets/form/datasheet-form").then(m => m.DatasheetForm),
      },
    ],
  },

  // Instruments
  {
    path: "instruments",
    canActivateChild: [isLoggedIn, hasUserTypes(UserAccountType.Admin, UserAccountType.Bactoforce)],
    children: [
      {
        path: "",
        loadComponent: () => import("./instruments/list/instruments-list").then(m => m.InstrumentsList),
      },
      {
        path: "create",
        loadComponent: () => import("./instruments/form/instrument-form").then(m => m.InstrumentForm),
      },
      {
        path: ":instrumentId",
        children: [
          {
            path: "",
            loadComponent: () => import("./instruments/form/instrument-form").then(m => m.InstrumentForm),
          },
          // Calibrations
          {
            path: "calibrations",
            children: [
              {
                path: "create",
                loadComponent: () => import("./instruments/calibrations/form/calibration-form").then(m => m.CalibrationForm),
              },
              {
                path: ":calibrationId",
                loadComponent: () => import("./instruments/calibrations/form/calibration-form").then(m => m.CalibrationForm),
              },
            ],
          },
        ],
      },
    ],
  },

  // Materials
  {
    path: "materials",
    canActivateChild: [isLoggedIn, hasUserTypes(UserAccountType.Admin, UserAccountType.Bactoforce)],
    children: [
      {
        path: "",
        loadComponent: () => import("./materials/list/materials-list").then(m => m.MaterialsList),
      },
      {
        path: "create",
        loadComponent: () => import("./materials/form/material-form").then(m => m.MaterialForm),
      },
      {
        path: ":materialId",
        children: [
          {
            path: "",
            loadComponent: () => import("./materials/form/material-form").then(m => m.MaterialForm),
          },
          // Batch Numbers
          {
            path: "batch-numbers",
            children: [
              {
                path: "create",
                loadComponent: () => import("./materials/batch-numbers/form/batch-numbers-form").then(m => m.BatchNumbersForm),
              },
              {
                path: ":batchNumberId",
                loadComponent: () => import("./materials/batch-numbers/form/batch-numbers-form").then(m => m.BatchNumbersForm),
              },
            ],
          },
        ],
      },
    ],
  },
] as const satisfies Routes;
